import { action } from "easy-peasy";
import { AppSettings } from "../interfaces/appSettings";
import { HeaderMode } from "../../types/HeaderMode";
import { ALL_WAREHOUSES } from "../../utility/capacityHelper";



export const appSettings: AppSettings = {
  headerMode: HeaderMode.Home,
  jobNumber: null,
  warehouses: [],
  bpNames: [],
  // Capacity Manager toolbar. The defaults are the ones the provider used to
  // hold in local state: every warehouse, released orders only, one month.
  capacityWarehouse: ALL_WAREHOUSES,
  capacityShowPlanned: false,
  capacityShowOneMonth: true,
  operationFilters: [],
  searchValue: undefined,
  startedJob: undefined,
  jobs: [],
  similarJobs: [],

  isManagerMode: false,

  isActiveJobMode: true,

  isDiagnosticPaneOpen: false,

  setHeaderMode: action((state, payload) => {
    state.headerMode = payload;
  }),

  setJobNumber: action((state, payload) => {
    state.jobNumber = payload;
  }),

  setWarehouses: action((state, payload) => {
    state.warehouses = payload;
  }),

  setBpNames: action((state, payload) => {
    state.bpNames = payload;
  }),

  setCapacityWarehouse: action((state, payload) => {
    state.capacityWarehouse = payload;
  }),

  setCapacityShowPlanned: action((state, payload) => {
    state.capacityShowPlanned = payload;
  }),

  setCapacityShowOneMonth: action((state, payload) => {
    state.capacityShowOneMonth = payload;
  }),

  setOperationFilters: action((state, payload) => {
    state.operationFilters = payload;
  }),

  setSearchValue: action((state, payload) => {
    state.searchValue = payload;
  }),

  setStartedJob: action((state, payload) => {
    state.startedJob = payload;
  }),

  setJobs: action((state, payload) => {
    state.jobs = payload;
  }),

  setSimilarJobs: action((state, payload) => {
    state.similarJobs = payload;
  }),
  
  setIsManagerMode: action((state, payload) => {
    state.isManagerMode = payload;
  }),

  setIsActiveJobMode: action((state, payload) => {
    state.isActiveJobMode = payload;
  }),

  setIsDiagnosticPaneOpen: action((state, payload) => {
    state.isDiagnosticPaneOpen = payload;
  }),

};
